export default __webpack_public_path__ + "c97c5c3.png";